import { useMediaQuery, Grid, Typography } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import { RichText } from 'prismic-reactjs';
import PropTypes from 'prop-types';

import { Image } from '@/src/components/atoms';
import { SectionHeader, CountUpNumber } from '@/src/components/molecules';

import SectionDynamic from './SectionDynamic';

// Custom styles
const useStyles = makeStyles(theme => ({
  coverImage: {
    [theme.breakpoints.down('sm')]: {
      maxWidth: 500,
    },
  },
}));

export default function Features(props) {
  const { className, section, image, title, subtitle, highlight, numbers, refElem, ...rest } =
    props;

  // Hooks
  const classes = useStyles();
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  // Constants
  const { url: imgSrc, alt: imgAlt } = image || {};

  // Actions
  const propsParseHandler = item => {
    const pre = RichText.asText(item);
    try {
      return JSON.parse(pre);
    } catch {
      return null;
    }
  };

  return (
    <SectionDynamic type={section}>
      <div className={className} ref={refElem} {...rest}>
        <Grid container spacing={isMd ? 4 : 2}>
          <Grid item xs={12} md={6} data-aos="fade-up">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SectionHeader
                  title={
                    <span>
                      {title}
                      <br />
                      <Typography component="span" variant="inherit" color="primary">
                        {highlight}
                      </Typography>
                    </span>
                  }
                  subtitle={subtitle}
                  align="left"
                  fadeUp
                  disableGutter
                />
              </Grid>
              <Grid item container xs={12} spacing={4}>
                {numbers.map((number, index) => (
                  <Grid item key={index.toString()}>
                    <CountUpNumber
                      start={number.count_start}
                      end={number.count_end}
                      label={number.count_label}
                      textColor={number.textColor || 'primary'}
                      suffix={number.count_suffix}
                      prefix={number.count_prefix}
                      countNumberProps={propsParseHandler(number.count_props)}
                    />
                  </Grid>
                ))}
              </Grid>
            </Grid>
          </Grid>
          <Grid
            item
            container
            justifyContent="center"
            alignItems="center"
            xs={12}
            md={6}
            data-aos="fade-up">
            {imgSrc && (
              <Image src={imgSrc} alt={imgAlt || 'Eskolare'} className={classes.coverImage} />
            )}
          </Grid>
        </Grid>
      </div>
    </SectionDynamic>
  );
}

Features.propTypes = {
  className: PropTypes.string,
  section: PropTypes.string,
  image: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  highlight: PropTypes.string,
  numbers: PropTypes.array.isRequired,
  refElem: PropTypes.any,
};
